
export enum TagType {
  CATEGORY = 'CATEGORY',
  COMPANY_VALUE = 'COMPANY_VALUE',
  FOUNDATION_STATEMENT = 'FOUNDATION_STATEMENT'
}
